import { Button } from '@/components/ui/button'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { useTranslation } from 'react-i18next'
import NewTeamModal from '../../../TeamDashboard/components/NewTeamModal'
import { useState } from 'react'
import ProtectedContent from 'app/frontend/base/components/ProtectedContent'

import Section from 'app/frontend/base/components/Section'
import GuildTeamCard from './components/GuildTeamCard'

const GuildTeams = () => {
  const { guild } = useGuild()
  const { t } = useTranslation()
  const [creatingTeam, setCreatingTeam] = useState(false)

  const sortedTeams = (guild?.teamReferences || []).sort(
    (a, b) => a.orderInGuild - b.orderInGuild,
  )

  return (
    <Section title={`Teams | ${guild?.name}`}>
      <h2 className='flex justify-between items-center'>
        <span>{t('shared.teams')}</span>
        <ProtectedContent
          section='base'
          requirement='admin'
          renderUnauthorized={false}
          requireAllTeams={true}
        >
          <Button size='sm' onClick={() => setCreatingTeam(true)}>
            {t('shared.create-new')}
          </Button>
        </ProtectedContent>
      </h2>

      {guild ? (
        <NewTeamModal setOpen={setCreatingTeam} open={creatingTeam} />
      ) : null}

      <div className='flex flex-col gap-2 text-sm'>
        {sortedTeams.map((team) => (
          <ProtectedContent
            key={team.id}
            section='base'
            requirement='member'
            teamReference={team}
            alwaysRenderContent={true}
          >
            <GuildTeamCard team={team} />
          </ProtectedContent>
        ))}
      </div>
    </Section>
  )
}

export default GuildTeams
